module.exports = __webpack_public_path__ + "static/media/edit-lock-button-inverted.fccb036b.svg";